export default __webpack_public_path__ + "static/media/LogoMinisterioDelTrabajo.867e2143.webp";